import { Head, router, useForm, usePage } from "@inertiajs/react"

import {
  InterviewForm,
  type InterviewFormData,
} from "@/components/interviews/interview-form"
import AppLayout from "@/layouts/app-layout"
import { interviewPath } from "@/routes"

interface Interview {
  id: number | string
  title: string
  interviewee_name?: string | null
  status: string
  content: string
  cover_url?: string | null
}

export default function InterviewsEdit() {
  const page = usePage<{ interview: Interview }>()
  const { interview } = page.props

  const { data, setData, patch, processing, errors } =
    useForm<InterviewFormData>({
      title: interview.title ?? "",
      interviewee_name: interview.interviewee_name ?? "",
      status: (interview.status as InterviewFormData["status"]) ?? "published",
      content: interview.content ?? "",
      cover: null as File | null,
      cover_url: interview.cover_url ?? "",
    })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    patch(interviewPath(interview.id), {
      forceFormData: true,
    })
  }

  return (
    <AppLayout>
      <Head title={`Editar - ${interview.title}`} />
      <div className="mx-auto max-w-6xl p-4 md:p-6">
        <InterviewForm
          title="Editar entrevista"
          data={data}
          errors={errors as Record<string, string>}
          processing={processing}
          onChange={(partial) => {
            Object.entries(partial).forEach(([key, value]) => {
              setData(
                key as keyof InterviewFormData,
                value as InterviewFormData[keyof InterviewFormData],
              )
            })
          }}
          onSubmit={handleSubmit}
          onCancel={() => router.visit(interviewPath(interview.id))}
          submitLabel="Guardar cambios"
          currentCover={interview.cover_url ?? null}
        />
      </div>
    </AppLayout>
  )
}
